import React, { FC, ReactNode, Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { checkCookie, selectUserToken } from 'src/store/api/auth';
import { CSpinner } from '@coreui/react-pro';

import './scss/style.scss';
import 'react-notifications/lib/notifications.css';

import './axiosConfig';

// Containers
const PrivateLayout = React.lazy(() => import('src/layout/PrivateLayout'));
const PublicLayout = React.lazy(() => import('src/layout/PublicLayout'));

const App: FC<ReactNode> = () => {
  const dispatch = useAppDispatch();
  const userToken = useAppSelector(selectUserToken);

  useEffect(() => {
    dispatch(checkCookie());
  }, [dispatch]);

  return (
    <BrowserRouter>
      <Suspense fallback={<CSpinner color="primary" />}>
        <Switch>
          <Route path="/" render={() => (userToken ? <PrivateLayout /> : <PublicLayout />)} />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
